import React, { useState } from 'react'
import { Box } from '@mui/system'
import { Collapse, IconButton, useTheme } from '@mui/material'
import { ChevronRight } from '@mui/icons-material'
import Section from './Section'
import TV from '../../../../../assets/icons/devices/Tv.svg'
import Document from '../../../../../assets/icons/Documents/Document.svg'
import { SectionState } from '../../../../../features/types'

interface Props {
    sections?: any[]
    handleSelect?: (section: any) => void
    selectedSection?: SectionState
}

const TopicProgressCard: React.FC<Props> = ({ sections, handleSelect }) => {
    const theme = useTheme()
    const [expanded, setExpanded] = useState(false)

    const styles = {
        wrapper: {
            border: `1px solid ${theme.palette.grey[100]}`,
            borderRadius: '8px',
            mb: 2,
            minWidth: '500px',
        },
        container: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            background: theme.palette.grey[100],
            cursor: 'pointer',
            p: 1,
            pr: 2,
        },
        chevron: {
            transform: expanded ? 'rotate(90deg)' : 'rotate(0)',
            transition: '0.15s ease-in-out',
        },
        flexCenter: {
            display: 'flex',
            alignItems: 'center',
        },
    }

    return (
        <Box sx={styles.wrapper}>
            <Box
                sx={styles.container}
                onClick={() => setExpanded(!expanded)}
            >
                <Box sx={styles.flexCenter}>
                    <IconButton>
                        <ChevronRight sx={styles.chevron} />
                    </IconButton>

                    <Box ml={1}>Кинематика</Box>
                </Box>

                <Box sx={styles.flexCenter}>
                    <Box sx={{ ...styles.flexCenter, mr: 1, ml: 1 }}>
                        <img
                            alt={'document'}
                            src={Document}
                        />
                        3
                    </Box>

                    <Box sx={styles.flexCenter}>
                        <img
                            alt={'tv'}
                            src={TV}
                        />
                        4
                    </Box>
                </Box>
            </Box>

            <Collapse in={expanded}>
                <Box>
                    {sections?.map((section, index) => (
                        <Section
                            key={section.id}
                            section={section}
                            isLast={index === sections.length - 1}
                            handleSelect={() => handleSelect(section)}
                        />
                    ))}
                </Box>
            </Collapse>
        </Box>
    )
}

export default TopicProgressCard
